import React from "react";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "router/permissions";
import SaveIcon from "@mui/icons-material/Save";
import RegularButton from "components/CustomButtons/Button";

export const SaveInventoryButton = ({ handleSave }) => {
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { INVENTORIES_CONTROL_EDIT } = PERMISSIONS;
  const { rules } = useSelector(({ login }) => login);
  const isEdit = rules.includes(INVENTORIES_CONTROL_EDIT);
  return (
    <>
      {isEdit && (
        <RegularButton
          round
          justIcon
          color="success"
          onClick={handleSave}
          tooltip="Guardar"
          disabled={isLoadingComp?.loadingSavingInventory}
          size="sm"
        >
          <SaveIcon style={{ margin: 0 }} />
        </RegularButton>
      )}
    </>
  );
};
